import React from 'react'
import PropTypes from 'prop-types'
// import request from 'superagent'
// import moment from 'moment'
import R from 'ramda'

import {
  Label,
  Image
} from 'semantic-ui-react'

import LineItem from '_views/lineItem'

import {
  PAGES
} from '_constants'

import {
  get,
  post
} from '_utils/xhr'

import {
  notNilOrEmpty,
  isNilOrEmpty,
  productNameToUpper,
  getFsUrl
} from '_utils'

const getProductName = R.compose(
  productNameToUpper,
  R.prop('name')
)
const productIsSub = R.compose(
  R.test(/subscription/i),
  getProductName
)

const getReference = R.compose(
  R.filter(notNilOrEmpty),
  R.split(' '),
  R.defaultTo(''),
  R.prop('reference')
)

const getIdImage = R.path(['surveys', 'id_image'])
const getMax6Serial = R.path(['surveys', 'max6_serial'])
const getMaxForLiveSerial = R.path(['surveys', 'max4live_serial'])
const getMax7Plus = R.path(['surveys', 'max7plus_license'])
const getSchoolName = R.path(['surveys', 'school_name'])
const getFieldOfStudy = R.path(['surveys', 'field_of_study'])
const getStudentPurchaseReason = R.path(['surveys', 'student_purchase_reason'])
const getStudentId = R.path(['surveys', 'student_id'])

const getTest = R.compose(
  R.cond([
    [R.equals('false'), R.always(null)],
    [R.equals(false), R.always(null)],
    [R.equals('true'), R.always('true')],
    [R.equals(true), R.always('true')],
    [R.T, R.always(null)]
  ]),
  R.prop('test')
)
const getStatus = R.propOr('completed', 'status')
const getReturnStatus = R.propOr('none', 'returned')
const getReturnId = R.path(['deactivated_info', 'return', 'id'])
const getClassicMigrationDate = R.prop('migrated_from_classic_on')

const getSubStatus = R.pathOr('', ['subscription', 'status'])
const getSubStatusReason = R.pathOr('', ['subscription', 'status_reason'])
const getSubStatusChangedOn = R.pathOr('', ['subscription', 'status_changed_on'])

const getSubReference = R.pathOr('', ['subscription', 'reference'])
const getSubEndDate = R.pathOr('', ['subscription', 'end_date'])
const getSubNextPeriod = R.pathOr('', ['subscription', 'next_period'])

const getCustomerName = R.pathOr('', ['customer', 'full_name'])
const getCustomerEmail = R.pathOr('', ['customer', 'email'])

const getPurchasedOn = R.prop('created')
const getUpgradedLic = R.prop('upgraded_license_id')
// we not only have images but also pdf's.  since we don't store the mime types of images (yet, we could)
// we can tryt o
const getIdImageComponent = (url, mime) => notNilOrEmpty(url)
  ? notNilOrEmpty(mime) && /pdf/i.test(mime)
    ? (<a href={url} target='_blank' style={{ float: 'right' }} rel='noreferrer' >idImage.PDF</a>)
    : (<Image src={url} style={{float: 'right', maxWidth: '200px', maxHeight: '200px'}} />)
  : null

class Fastspring extends React.PureComponent {
  state = {
    idImageUrl: null
  }
  componentDidMount () {
    if (this.state.idImageUrl) return
    const fastspring = R.path(['license', 'activated_info', 'fastspring'], this.props)
    const idImage = getIdImage(fastspring)
    if (!idImage) {
      return
    }
    const url = `/id_image/${idImage}`
    get(url, {})
      .then(body => {
        this.setState({
          idImageUrl: R.prop('sig', body),
          idImageMime: R.prop('content-type', body)
        })
      })
      .catch(e => console.log(e))
  }
  onSnClick = e => {
    e.preventDefault()
    const sn = R.path(['license', 'activated_info', 'fastspring', 'surveys', 'max6_serial'], this.props)
    this.props.setNavigation({pageName: PAGES.SERIALS, ids: [sn]})
  }
  sendRetrievalCode = () => {
    const licenseId = R.path(['license', '_id'], this.props)
    const custEmail = R.path(['license', 'activated_info', 'fastspring', 'customer', 'email'], this.props)
    const displayName = R.path(['license', 'activated_info', 'fastspring', 'customer', 'full_name'], this.props)
    const url = `/licenses/${licenseId}/send_ret_code`
    const email = window.prompt(`Resend the retrieval code for ${displayName} at?:`, custEmail)
    if (email) {
      post(url, {email})
        .then(R.tap(console.log))
        .catch(e => console.log(e))
    }
  }

  render () {
    const fastspring = R.path(['license', 'activated_info', 'fastspring'], this.props)
    const fastspringClassic = R.path(['license', 'activated_info', 'fastspring_classic'], this.props)
    const orderRefs = getReference(fastspring)
    const fromLic = getMax7Plus(fastspring)
    const toLic = getUpgradedLic(this.props.license)
    const fromLicClick = _ => this.props.setNavigation({pageName: PAGES.LICENSES, ids: [fromLic]})
    const toLicClick = _ => this.props.setNavigation({pageName: PAGES.LICENSES, ids: [toLic]})

    return (
      <div>
        { getIdImageComponent(this.state.idImageUrl, this.state.idImageMime) }
        { isNilOrEmpty(R.path(['license', 'user_id'], this.props))
          ? <Label as='a' icon='mail' content='resend retrieval url' onClick={this.sendRetrievalCode} style={{marginBottom: '1rem'}} />
          : null
        }
        <LineItem
          label={ R.propEq('length', 1, orderRefs) ? 'Order' : 'Orders'}
        >
          {
            orderRefs
              .map((ref, idx) => <Label as='a'
                style={{marginBottom: '0.25em'}}
                key={ref}
                href={getFsUrl('order')(ref)}
                target='_blank'
                content={ref}
              />)
          }
        </LineItem>
        <LineItem label='Reference' text={R.prop('reference_user', fastspring)} />
        <LineItem label='Purchased on' text={getPurchasedOn(fastspring)} isDate />
        <LineItem label='Customer Name' text={getCustomerName(fastspring)} />
        <LineItem label='Customer Email' text={getCustomerEmail(fastspring)} />
        <LineItem label='Serial Number' text={getMax6Serial(fastspring)} onClick={this.onSnClick} />
        <LineItem label='MFL Serial Number' text={getMaxForLiveSerial(fastspring)} />
        <LineItem label='School Name' text={getSchoolName(fastspring)} />
        <LineItem label='Field of Study' text={getFieldOfStudy(fastspring)} />
        <LineItem label='Student Purchase Reason' text={getStudentPurchaseReason(fastspring)} />
        <LineItem label='Student Id' text={getStudentId(fastspring)} />
        <LineItem label='Test' text={getTest(fastspring)} />
        <LineItem label='Status' text={getStatus(fastspring)} />
        <LineItem label='Migrated from FS Classic on' text={getClassicMigrationDate(fastspring)} />
        { productIsSub(fastspring)
          ? (
            <React.Fragment>
              <LineItem
                label='Subscription Reference'
                href={getFsUrl('sub')(getSubReference(fastspring))}
                text={getSubReference(fastspring)}
              />
              <LineItem label='Subscription Status' text={getSubStatus(fastspring)} />
              <LineItem label='Subscription Reason' text={getSubStatusReason(fastspring)} />
              <LineItem label='Subscription Changed On' text={getSubStatusChangedOn(fastspring)} isDate={true} />
              <LineItem label='Subscription Next Period' text={getSubNextPeriod(fastspring)} isDate={true} />
              <LineItem label='Subscription Ends On' text={getSubEndDate(fastspring)} isDate={true}/>
              {fastspringClassic ? (
                <LineItem
                  label='FS Classic Subscription Reference'
                  href={getFsUrl('sub')(getSubReference(fastspringClassic))}
                  text={getSubReference(fastspringClassic)}
                />
              ) : null}
            </React.Fragment>
          )
          : null
        }
        <LineItem label='Return Status' text={getReturnStatus(fastspring)} />
        <LineItem
          label='Returned'
          href={getFsUrl('return')(getReturnId(this.props.license))}
          text={getReturnId(this.props.license)}
        />
        <LineItem
          label='Upgraded from'
          text={fromLic}
          onClick={fromLicClick}
        />
        <LineItem
          label='Upgraded to'
          text={toLic}
          onClick={toLicClick}
        />

      </div>
    )
  }
}

Fastspring.propTypes = {
  license: PropTypes.object.isRequired,
  setNavigation: PropTypes.func.isRequired
}

export default Fastspring



// WEBPACK FOOTER //
// ./webAdmin/views/license/fastspring.js